module.exports = __webpack_public_path__ + "static/media/bc_cover_inner.8b3b5575.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/bc_cover_inner.png
// module id = 183
// module chunks = 0